import { styles, variants, TextFieldTheme } from '../TextFieldStyles.css';
import { baseTheme } from './TextFieldBaseTheme.css';
import { multiVariantStyles } from './TextFieldVariants.css';

const TextFieldRedwoodTheme: TextFieldTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TextFieldRedwoodTheme };
